import { Image } from "./image";
import { Lightbox } from "./lightbox";
import React, { useState } from "react";

// Wie viele Kacheln vor dem Klick auf "Mehr anzeigen" sichtbar sind.
// 8 ergibt auf dem Handy 4 Reihen – genug zum Antesten, ohne dass die
// Startseite endlos lang wird.
const INITIAL_COUNT = 8;

export const Gallery = (props) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [expanded, setExpanded] = useState(false);

  const items = props.data || [];
  const visible = expanded ? items : items.slice(0, INITIAL_COUNT);
  const hidden = items.length - visible.length;

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Galerie</h2>
          <p>
            Lassen Sie sich von unseren modernen Innenausbauten, Beleuchtungslösungen und Fassadengestaltungen inspirieren.
          </p>
        </div>

        <div className="gallery-grid">
          {visible.map((d, i) => (
            <Image
              key={d.smallImage}
              title={d.title}
              smallImage={d.smallImage}
              largeImage={d.largeImage}
              position={i + 1}
              total={items.length}
              onOpen={() => setActiveIndex(i)}
            />
          ))}
        </div>

        {hidden > 0 && (
          <button
            type="button"
            className="btn btn-custom btn-lg gallery-more"
            onClick={() => setExpanded(true)}
          >
            {`Weitere ${hidden} Bilder anzeigen`}
          </button>
        )}
      </div>

      <Lightbox
        items={items}
        index={activeIndex}
        onClose={() => setActiveIndex(null)}
        onNavigate={setActiveIndex}
      />
    </div>
  );
};
